import { ViewActions, ViewActionButton } from '@/formUi'
import { useTexts } from './useTexts'

type Props = {
  onEdit: () => void
}

export function GpsFormatsViewActions(props: Props) {
  const { onEdit } = props

  const texts = useTexts()

  return (
    <ViewActions>
      <ViewActionButton
        onClick={onEdit}
        label={texts.edit}
        testId="edit-button"
        data-testid="settings-gps-formats-edit-button"
        data-trackid="settings-gps-formats-edit-button"
      />
    </ViewActions>
  )
}
